define('TescoMobile_DataLayer/js/datalayer-section',['jquery', 'underscore', 'Magento_Customer/js/customer-data', 'domReady!'], function ($, _, customerData) {
  'use strict';

  function init(event) {
    var datalayerSection = customerData.get('datalayer');
    var eventJsonBase = event.eventData;
    const sentEventIds = [];
    datalayerSection.subscribe(function (updatedDL) {
      var eventJson = {};
      $.extend(eventJson, eventJsonBase, updatedDL);
      delete eventJson.data_id;
      if (updatedDL.add_pagetype_data) {
        delete eventJson.add_pagetype_data;
        _.each(updatedDL.add_pagetype_data, function (index) {
          if (typeof utag_data[index] !== 'undefined') {
            eventJson[index] = utag_data[index];
          }
        });
      }
      if (eventJson.event_name !== 'all_section_data_events') {
        if (eventJson !== null && eventJson !== void 0 && eventJson.event_uuid) {
          if (sentEventIds.includes(eventJson.event_uuid)) {
            return;
          }
          sentEventIds.push(eventJson.event_uuid);
          delete eventJson.event_uuid;
        }
        sendEvent(event.eventType, eventJson);
      }
    });
  }
  function sendEvent(eventType, eventJson) {
    var eventDetail = $.extend(true, {}, eventJson);
    var e = new CustomEvent(eventType, {
      detail: eventDetail
    });
    document.dispatchEvent(e);
  }
  ;
  return function (config) {
    init(config);
  };
});

